export default __webpack_public_path__ + "static/media/octahedron.1673e3ed.jpg";